export const MAIN_CLASS_NAME = 'elma365-process-table';
export const SEARCH_CLASS_NAME = `${MAIN_CLASS_NAME}__search`;
export const CHECKBOX_CLASS_NAME = `${MAIN_CLASS_NAME}__checkbox`;

export const PROCESS_PAGE_SIZE = 250;
